import { request } from '../../../gateways/api'
import type { AdditioneleVraagResponse } from '../types/AdditioneleVraag'

export { fetchKlantAdditioneleVragen }

const fetchKlantAdditioneleVragen = async ({
  id,
}: {
  id: string
}): Promise<AdditioneleVraagResponse[]> => {
  const result = await request({
    url: `/rest/project/${id}/additionelevragen`,
    method: 'GET',
  })

  return result
}
